import React from "react";
import Rest from "../../../../helpers/Rest";
import {Grid, MenuItem, useTheme, useMediaQuery} from "@material-ui/core";
import {
    DEFAULT_SELECTOR_VALUE, getDateFilterClause,
    SonaSafeDateSelectorField, SonaSafeTextField, filter
} from "../../components/Selectors";
import ProgressOr from "../../../../components/ProgressOr";
import Widget from "../../../../components/Widget";
import GoogleMap from "../../../../components/GoogleMap";
import useStyles from "./styles"
import { FixedSizeList as List } from 'react-window';
import PositionMonitor from "../../../../helpers/PositionMonitor";
import COLLISION_EVENT from "./Types/CollisionEvent"
import GPS_EVENT from "./Types/GpsEvent"
import ZONE_EVENT from "./Types/ZoneEvent";
import CAMERA_EVENT from "./Types/CameraEvent";

const EVENT_TYPES = [COLLISION_EVENT, GPS_EVENT, ZONE_EVENT, CAMERA_EVENT]
const EVENT_TYPE_LOOKUP = {}
EVENT_TYPES.forEach(type => EVENT_TYPE_LOOKUP[type.type] = type)

const MAP_HEIGHT = 200, MAP_WIDTH = 300, MARKER_SIZE = 24
const REFRESH_AFTER_MILLIS = 1000
const POLL_INTERVAL = 15000

function getMarkerIcon(marker){
    const {Size, Point} = window.google.maps
    const offset = MARKER_SIZE * 0.5
    return {
        url: marker,
        scaledSize: new Size(MARKER_SIZE, MARKER_SIZE),
        anchor: new Point(offset, offset)
    }
}

class DeviceEventMap extends React.Component{
    constructor(props) {
        super(props);
        this.state = {}
    }

    getBounds(){
        const bounds = new window.google.maps.LatLngBounds();
        this.props.markers.forEach(marker => bounds.extend(marker.pos));
        return bounds;
    }

    drawMarker(map, marker){
        const {pos, radius, svg} = marker
        if (radius) {
            (new window.google.maps.Circle({
                strokeWeight: 0,
                fillColor: this.props.theme.palette.primary.light,
                fillOpacity: 0.3,
                center: pos,
                radius: radius
            })).setMap(map);
        }
        (new window.google.maps.Marker({
            icon: getMarkerIcon(svg),
            position:pos
        })).setMap(map);
    }

    createMap(google){
        const map = google.createMap({
            center: this.props.pos,
            zoom: 11,
            mapTypeId: google.api.MapTypeId.HYBRID,
            fullscreenControl: false,
            scaleControl: false,
            rotateControl: false,
            streetViewControl: false,
            zoomControl: false,
            mapTypeControl: false,
            tilt: 0
        });
        (this.props.markers || []).forEach(marker => this.drawMarker(map, marker));
        this.setState({
            map: map
        })
    }

    render(){
        const {pos} = this.props
        if (!pos){
            return null
        }
        const {map} = this.state
        if (map) {
            map.setCenter(pos)
            map.fitBounds(this.getBounds())
        }
        return (
            <GoogleMap style={{maxWidth:`${MAP_WIDTH}px`, height:`${MAP_HEIGHT}px`}}>{
                maps => this.createMap(maps)
            }</GoogleMap>
        )
    }
}

function menuItem(type){
    const id = type.type
    return (
        <MenuItem key={id} value={id}>
            {type.label}
        </MenuItem>
    )
}

class DeviceEvents extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            type: this.fetchDefaultType(),
            date: DEFAULT_SELECTOR_VALUE,
            listHeight: 0
        }
        this.nextCheck = {}
    }

    getDefaultType(){
        switch (this.props.deviceType){
            case "VDU":
            case "MST":
            case "LVU":
                return COLLISION_EVENT
            case "GDU":
                return GPS_EVENT
            case "CAM":
                return CAMERA_EVENT
            default:
                return ZONE_EVENT
        }
    }

    stamp(type){
        this.nextCheck[type] = new Date().getTime() + REFRESH_AFTER_MILLIS
    }

    shouldRefresh(type){
        const check = this.nextCheck[type]
        return check && new Date().getTime() >= check
    }

    fetchEvents(type){
        Rest.get(`device/${this.props.deviceId}/${type}/list`).then(list => {
            this.stamp(type)
            this.setState({
                [type]: list
            })
        })
    }

    componentDidMount() {
        /*this.handle = window.setInterval(() => {
            const {type} = this.state
            if (type){
                this.fetchEvents(type.type)
            }
        }, POLL_INTERVAL)*/
    }

    componentWillUnmount() {
        window.clearInterval(this.handle)
    }

    getEvents(type) {
        const existing = this.state[type]
        if (existing){
            return existing
        }
        this.fetchEvents(type)
        return []
    }

    fetchDefaultType(){
        const type = this.getDefaultType()
        this.fetchEvents(type.type)
        return type
    }

    applyFilters(type){
        return filter([getDateFilterClause(type.timestampOffset, this.state.date)], this.getEvents(type.type))
    }

    setType(e){
        this.setState({
            type: EVENT_TYPE_LOOKUP[e.target.value],
            date: DEFAULT_SELECTOR_VALUE
        })
    }

    setDate(e){
        this.setState({date: e.target.value})
    }

    filters(type){
        const rows = this.state[type.type]
        if (!rows){
            return ""
        }
        const dates = rows.map(event => event[type.timestampOffset])
        return (
            <Grid container item xs={12} spacing={2}>
                <Grid item xs={12} sm={6}>
                    <SonaSafeTextField label="Type" value={type.type} onChange={this.setType.bind(this)} select>
                        {EVENT_TYPES.map(menuItem)}
                    </SonaSafeTextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SonaSafeDateSelectorField dates={dates} value={this.state.date} onChange={this.setDate.bind(this)}/>
                </Grid>
            </Grid>
        )
    }

    getListItem(type, items){
        if (type.getPosition){
            return ({index, style}) => {
                const event = items[index]
                return (
                    <div style={style}>
                        <Widget disableWidgetMenu>
                            <Grid container spacing={2} justify="center">
                                <Grid container item spacing={2} xs={12} md={6}>
                                    {type.getProperties(event, this.props.deviceType, this.props.classes)}
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <DeviceEventMap
                                        theme={this.props.theme}
                                        pos={type.getPosition(event)}
                                        markers={type.getMarkers(event)}
                                    />
                                </Grid>
                            </Grid>
                        </Widget>
                    </div>
                )
            }
        }
        return ({index, style}) => {
            const event = items[index]
            return (
                <div style={style}>
                    <Widget disableWidgetMenu>
                        <Grid container spacing={2}>
                            {type.getProperties(event, this.props.deviceType, this.props.classes)}
                        </Grid>
                    </Widget>
                </div>
            )
        }
    }

    getItemSize(){
        const itemSize = MAP_HEIGHT + (this.props.theme.spacing(8))
        return this.props.sm ? itemSize * 2 : itemSize
    }

    events(type){
        const items = this.applyFilters(type)
        const listItem = this.getListItem(type, items), itemSize = this.getItemSize()
        return (
            <Grid item xs={12} className={this.props.classes.eventDetails}>
                <PositionMonitor>{pos => {
                    this.setState({
                        listHeight: window.innerHeight - pos.y - this.props.theme.spacing(4)
                    })
                }}</PositionMonitor>
                <List itemCount={items.length}
                      itemSize={itemSize}
                      width="100%"
                      height={this.state.listHeight}
                >
                    {listItem}
                </List>
            </Grid>
        )
    }

    render(){
        const type = this.state.type
        const typeKey = type.type
        if (this.shouldRefresh(typeKey)){
            this.fetchEvents(typeKey)
        }
        return (
            <ProgressOr showProgress={this.state[typeKey] === undefined}
                        progressMessage={`Fetching events for ${this.props.deviceName}...`}>
                <Grid container spacing={2} className={this.props.classes.main}>
                    {this.filters(type)}
                    {this.events(type)}
                </Grid>
            </ProgressOr>
        )
    }
}

export default (props) => {
    const theme = useTheme()
    const classes = useStyles(theme)
    const sm = useMediaQuery(theme.breakpoints.down("sm"))
    if (!props.deviceId){
        return ""
    }
    return (
        <DeviceEvents theme={theme} sm={sm} classes={classes} {...props}/>
    )
}
